import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
// import Contact from "./components/Contact";
// import About from "./components/About";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<App />} />
        </Routes>
      </Layout>
    </Router>
  </React.StrictMode>
);
